import React, {useState, useEffect} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import Header from "./Header";
import TotalExpensesButton from "./TotalExpensesButton";
import ExpenseBreakdownButton from "./ExpenseBreakdownButton";
import BaseContainerDividingLineRHSSidebar from "./BaseContainerDividingLineRHSSidebar";
import rect6451 from "../img/rectangle-6518@2x.svg"
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import ExpenseListInput from "./ExpenseListInput";
import TotalExpenses from "./TotalExpenses";
import ExpenseBreakdownPageComponent from "./ExpenseBreakdownPageComponent";
import union from "../img/union@2x.svg";
import './Expenses.css';



const Expenses = () => {
    const [expenses, setExpenses] = useState("Input Total Expenses");
    const [expenseBreakdown, setexpenseBreakdown] = useState(false);
    const [totalExpensesBool, settotalExpensesBool] = useState(false);
    const [expense, setTotalExpenses] = useState(0);
    const [expenseList, setExpenseList] = useState("");
    const [inputList, setInputList] = useState(false)

    const { user } = useAuth0();

    useEffect(() => {
        setInputList(false)
        expenses === "Input Total Expenses" ? settotalExpensesBool(true) && setInputList(false) : settotalExpensesBool(false);
        expenses === "Choose Your Expenses" ? setexpenseBreakdown(true) : setexpenseBreakdown(false) && setInputList(false);
    }, [expenses]);

    const handleOnChange = (e) => {
        setExpenses(e.target.value);
        setexpenseBreakdown(e.target.value);
    }

    function renderResults(){
        let result;
        expenses === "select-expenses"
            ? (result = "Select Expenses Breakdown")
            : (result = expenses);
        return result;
    };

    const getTotalExpenses = (totalExpense) => {
        setTotalExpenses(totalExpense);
        return totalExpense;
    }

    const getExpensesTypes = (expenseListData) => {
        setExpenseList(expenseListData);
        return expenseListData;
    }

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('Total Expenses: ',expense)
        axios.get(`http://localhost:4000/EXPENSES/add?ExpenseID=${user.sub}&total=${expense}`)
            .then(response => {
                console.log(response)
                // setSaving(false);
            })
            .catch(error => {
                console.log(error)
            })
    }

    const onSubmitBreakdown = (e) => {
        e.preventDefault();
        console.log('LIST: ', expenseList)
        setInputList(true);
        setexpenseBreakdown(false);

    }


    return(
        <div className="container-center-horizontal">
            <div className="expenses-home-page screen">
                <div className="flex-col-21">
                    <Header />
                    <div className="overlap-group6">
                        <BaseContainerDividingLineRHSSidebar />
                        <div className="expense-plan">
                            <div className="expense-plan-2 nunito-bold-black-16px">Expense Breakdown: {renderResults()}</div>
                        </div>
                        <img className="rectangle-6451" src={rect6451} />
                        <div className="expenses-17 nunito-bold-black-30px">Expenses</div>
                        <div className="rectangle-6440 border-1px-athens-gray-2"></div>
                        <div className="change-plan total-after-tax-expenses">
                            <div className="change-plan-1 nunito-bold-black-20px">Total After Tax Expenses</div>
                        </div>
                        <div className="rectangle-6452-2 border-1px-athens-gray-2"></div>
                        <select 
                            className="expense-plan-dropdown"
                            placeholder="Expense Breakdown Options"
                            value={expenses}
                            onChange={handleOnChange}
                        >
                            <option value="Choose Your Expenses">Detailed Breakdown</option>
                            <option value="Input Total Expenses">Input Total Expenses</option>
                        </select>
                        <form onSubmit={onSubmit}>  
                            {totalExpensesBool && <TotalExpenses getTotalExpenseData={getTotalExpenses} />}
                            {totalExpensesBool && <button type="submit" className="save-button-expenses">Save</button>}
                        </form>
                        <form onSubmit={onSubmitBreakdown}>
                            {expenseBreakdown && <ExpenseBreakdownPageComponent getExpenseTypesData={getExpensesTypes} />}
                            {expenseBreakdown && <button type="submit" className="save-button-expenses-breakdown">Save</button>}
                        </form>
                        {inputList && <ExpenseListInput expenses={expenseList} />}
                        <NextButton nextPage="/expense-breakdown-page" />
                        <BackButton backPage="/investments" />
                        <TotalExpensesButton className="nunito-bold-azure-radiance-14px" logo={union} />
                        <ExpenseBreakdownButton />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Expenses;